// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"_1pZmR"};